import React from "react";
import Banner from "../components/Banner";
import BookingForm from "../components/BookingFrom";
import FleetInformation from "../components/FleetInformation";
import GoogleReviewsSlider from "../components/GoogleReviewsSlider";
import Footer from "../components/Footer";

const HomePage = () => {
	return (
		<>
			<Banner />
			<BookingForm />
			<FleetInformation />
			<GoogleReviewsSlider />
			<Footer />
		</>
	);
};

export default HomePage;
